import { render, staticRenderFns } from "./SupplierStatusChart.vue?vue&type=template&id=2b66de7b&"
import script from "./SupplierStatusChart.vue?vue&type=script&lang=ts&"
export * from "./SupplierStatusChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports